import { useWindowDimensions } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";
import styled from "styled-components";

const SMALL_SCREEN_WIDTH = 800;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  @media (max-width: 800px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: ${spacing.m}px;

  @media (max-width: 800px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const useStyles = () => {
  const { width } = useWindowDimensions();

  const cardLargeWidth = width * 0.8 + constants.divPadding * 4 + spacing.m;
  const cardSmallWidth = width * 0.8 + constants.divPadding * 2;
  const cardInnerWidth = width >= SMALL_SCREEN_WIDTH ? cardLargeWidth : cardSmallWidth;

  const styles: Record<string, CSSProperties> = {
    container: {
      marginLeft: constants.divPadding,
      marginRight: constants.divPadding,
    },
    spacing: {
      marginLeft: spacing.xs,
      marginRight: spacing.xs,
    },
    divider: {
      width: width >= SMALL_SCREEN_WIDTH ? spacing.m : 0,
      height: width >= SMALL_SCREEN_WIDTH ? 0 : spacing.m,
    },
    exclusive: {
      flex: undefined,
      flexShrink: undefined,
    },
    headerContainer: {
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
    },
    cardContainer: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    cardInnerContainer: {
      width: cardInnerWidth,
    },
    bannerInnerContainer: {
      width: cardInnerWidth,
      flexDirection: "column",
      alignItems: "stretch",
    },
    leftCard: {
      flex: width >= SMALL_SCREEN_WIDTH ? 2.2 : undefined,
      minWidth: 0,
      boxSizing: "border-box",
      width: width >= SMALL_SCREEN_WIDTH ? undefined : "100%",
    },
    rightCard: {
      flex: width >= SMALL_SCREEN_WIDTH ? 1 : undefined,
      minWidth: 0,
      boxSizing: "border-box",
      width: width >= SMALL_SCREEN_WIDTH ? undefined : "100%",
    },
    half: {
      flex: width >= SMALL_SCREEN_WIDTH ? 1 : undefined,
      minWidth: 0,
      boxSizing: "border-box",
      width: width >= SMALL_SCREEN_WIDTH ? undefined : "100%",
    },
  };

  return styles;
};
